// extracted by mini-css-extract-plugin
module.exports = {"root":"topbar-user-menu-unlogged_root__IkZpA"};